<template>
  <span class="has-text-danger ml-1">*</span>
</template>

<script>
export default {
  name: 'RequiredAsterisk'
}
</script>
